import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LinkComponent, ModalComponent, SnackbarComponent, SpinnerComponent, TagIconComponent } from '@tecalisdev/infinity';
import { Observable, Subscription } from 'rxjs';
import { ILoading } from './core/models/loading.models';
import { IModalConfirmation } from './core/models/modal-confirmation.models';
import { ISnackbar } from './core/models/snackbar.models';
import { DialogConfirmationService } from './core/services/dialog-confirmation.service';
import { LoadingService } from './core/services/loading.service';
import { SnackbarService } from './core/services/snackbar.service';
import { ModalChangeLanguageComponent } from './shared/components/modal-change-language/modal-change-language.component';
import { DesignService } from './shared/services/config/design.service';
import { normalizeDesignAssetSrc } from './shared/services/config/design/design-asset-src.util';

@Component({
	selector: 'app-root',
	imports: [
		CommonModule,
		RouterOutlet,
		ModalComponent,
		SnackbarComponent,
		SpinnerComponent,
		TagIconComponent,
		LinkComponent,
		TranslatePipe,
		ModalChangeLanguageComponent,
	],
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
	title = 'pwcs2';
	public customLoader: ILoading | null = null;
	public customLoadingIframe: Observable<ILoading>;
	public snackbar: Observable<ISnackbar>;
	public modalConfirmation: Observable<IModalConfirmation>;
	private subscriptions: Subscription = new Subscription();

	constructor(
		public snackbarService: SnackbarService,
		public designService: DesignService,
		public dialogConfirmationService: DialogConfirmationService,
		private loadingService: LoadingService,
		private cdr: ChangeDetectorRef,
	) {}

	ngOnInit() {
		this.subscriptions.add(
			this.loadingService.loading().subscribe((loader) => {
				this.customLoader = loader;
				this.cdr.detectChanges();
			}),
		);

		this.customLoadingIframe = this.loadingService.iframeLoading();
		this.snackbar = this.snackbarService.getSnackBar();
		this.modalConfirmation = this.dialogConfirmationService.getDialogConfirmation();
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	public onLoadingResumeClick(): void {
		// Figma: oculta el copy pero mantiene el hueco (no vaciar text → *ngIf del spinner).
		this.loadingService.patchLoading({ showResumePrompt: false, hideTextKeepSpace: true });
		this.loadingService.notifyResumeClick();
	}

	public resolveLoaderImage(explicitImg?: string | null): string {
		const fromLoader = this.sanitizeSpinnerUrl(explicitImg);
		if (fromLoader) {
			return fromLoader;
		}

		const fromDesign = this.designService.getCustomSpinnerUrl();
		if (fromDesign) {
			return fromDesign;
		}

		return undefined;
	}

	private sanitizeSpinnerUrl(value?: string | null): string | null {
		return normalizeDesignAssetSrc(value ?? null);
	}
}
